import api, { endpoints } from '@utils/api';

export const getMyCompanyUsers = async ({
  page = 1,
  pageSize = 20,
  search,
  company_role_id,
  is_active,
  role_name, 
}) => {
  try {
    const response = await api.get(endpoints.companiesUser, {
      params: {
        page,
        pageSize,
        search,
        company_role_id,
        is_active,
        role_name,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCompanyUser = async (userData) => {
  try {
    const response = await api.post(endpoints.companiesUser, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserStatus = async (userId, updateData) => {
  try {
    const response = await api.patch(`${endpoints.companiesUser}/${userId}/status`, updateData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyUser = async (userId, userData) => {
  try {
    const response = await api.put(`${endpoints.companiesUser}/${userId}`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCompanyUserById = async (userId) => {
  try {
    const response = await api.get(`${endpoints.companiesUser}/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCompanyUser = async (userId) => {
  try {
    const response = await api.delete(`${endpoints.companiesUser}/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
// Employee hierarchy — direct reports of managerId (top of the org when omitted)
export const getHierarchyChildren = async ({ managerId, page = 1, pageSize = 50, signal } = {}) => {
  const response = await api.get(`${endpoints.companiesUser}/hierarchy`, {
    params: { manager_id: managerId ?? undefined, page, pageSize },
    signal,
  });
  return response.data;
};

export const searchHierarchy = async ({ search, page = 1, pageSize = 20, signal }) => {
  const response = await api.get(`${endpoints.companiesUser}/hierarchy/search`, {
    params: { search, page, pageSize },
    signal,
  });
  return response.data;
};

// Reporting chain from the top of the org down to userId (last item is the user)
export const getHierarchyChain = async (userId, { signal } = {}) => {
  const response = await api.get(`${endpoints.companiesUser}/hierarchy/${userId}/chain`, { signal });
  return response.data;
};
